<template>
  <tag-list-show :tag-list="scope.row.showTags"></tag-list-show>
</template>

<script>
import TagListShow from '@/components/tag-list-show-new/index.vue'
export default {
  name: 'ListTableColumnTag',
  components: {
    TagListShow
  },
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
